define([
    "backbone-validation"
    ], function() {
        "use strict";

        var LoginModalView = App.View.extend({
            el: ".js-login-form-page",

            events: {
                submit: "onSubmit"
            },

            render: function(redirectUrl) {
                var $redirectField = this.$el.find(".js-login-redirect");
                if (!redirectUrl) {
                    return
                }
                if (!$redirectField.val()) {
                    $redirectField.val(redirectUrl);
                }
            },

            onSubmit: function() {
                this.buttons["btn-login-submit"].showLoading();
            },

            setRedirect: function(redirectUrl) {
                this.$el.find(".js-login-redirect").val(redirectUrl);
            },

            showModal: function(e) {
                this.isModal = true;

                App.Modal.showModal(e, {
                    modalElement : $(".js-login-modal"),
                    modalView    : this
                });
            }

        });

        return LoginModalView;
    });
